import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Volume2, VolumeX } from 'lucide-react';

interface MusicControlProps {
  onVolumeChange: (volume: number) => void;
}

export const MusicControl = ({ onVolumeChange }: MusicControlProps) => {
  const [isMuted, setIsMuted] = useState(() => {
    const stored = localStorage.getItem('musicMuted');
    return stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem('musicMuted', String(isMuted));
    onVolumeChange(isMuted ? 0 : 1);
  }, [isMuted, onVolumeChange]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <Button
      onClick={toggleMute}
      variant="ghost"
      size="icon"
      className="fixed bottom-4 right-4 z-50 bg-background/50 backdrop-blur-sm hover:bg-background/80"
      aria-label={isMuted ? 'Unmute music' : 'Mute music'}
    >
      {isMuted ? (
        <VolumeX className="h-5 w-5" />
      ) : (
        <Volume2 className="h-5 w-5" />
      )}
    </Button>
  );
};
